import CommonClient from './CommonClient';

class AxClient {
    common = new CommonClient();
}

export default new AxClient();
